import {EntityListWithPagination, PaginacionRequest} from "../../../../../types";
import {HttpAxiosRequest} from "../../../../../http/httpAxiosBase";
import {EventoRequestDTO, EventoVistaDTO} from "./schemas";

export const HttpEvento = {
    getEndpoint: (url: string) => `eventos${url}`,

    getEventos: (
        paginacion: PaginacionRequest,
        filter?: EventoRequestDTO
    ): Promise<EntityListWithPagination<EventoVistaDTO>> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(HttpEvento.getEndpoint(''), {...paginacion, ...filter})
    },
}